module.exports = __webpack_public_path__ + "60a18e61df246052653bb2b555b950d9.svg";